'use client';

import React, { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

export default function ChatWidget() {
  const [open, setOpen] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [formData, setFormData] = useState({ name: '', phone: '', email: '', message: '' });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
    setTimeout(() => {
      setSubmitted(false);
      setFormData({ name: '', phone: '', email: '', message: '' });
    }, 5000);
  };

  return (
    <div className="fixed bottom-5 right-5 z-50 flex flex-col items-end gap-3">
      {/* Chat Panel */}
      {open && (
        <div className="w-[320px] sm:w-[360px] bg-card border border-border rounded-2xl shadow-[0_20px_60px_rgba(27,67,50,0.2)] overflow-hidden animate-chat-pop">
          {/* Header */}
          <div className="bg-primary px-4 py-3 flex items-center justify-between">
            <div className="flex items-center gap-2.5">
              <div className="w-8 h-8 rounded-full bg-accent/20 flex items-center justify-center">
                <Icon name="ChatBubbleLeftRightIcon" size={16} className="text-accent" />
              </div>
              <div>
                <p className="text-sm font-semibold text-white">Empire Venture Nepal</p>
                <div className="flex items-center gap-1">
                  <div className="w-1.5 h-1.5 rounded-full bg-green-400" />
                  <p className="text-[10px] text-white/60">Leave a message</p>
                </div>
              </div>
            </div>
            <button
              onClick={() => setOpen(false)}
              className="p-1 rounded-md hover:bg-white/10 text-white/70 hover:text-white transition-colors"
              aria-label="Close chat"
            >
              <Icon name="XMarkIcon" size={16} />
            </button>
          </div>

          {/* Body */}
          <div className="p-4">
            {submitted ? (
              <div className="flex flex-col items-center justify-center py-8 gap-3">
                <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
                  <Icon name="CheckCircleIcon" size={24} className="text-primary" />
                </div>
                <p className="text-sm font-semibold text-foreground">Message Received!</p>
                <p className="text-xs text-muted-foreground text-center">
                  Our team will get back to you as soon as possible.
                </p>
              </div>
            ) : (
              <>
                <div className="bg-muted rounded-lg p-3 mb-4">
                  <p className="text-xs text-muted-foreground leading-relaxed">
                    Hi! Leave your details and our team will get back to you. For urgent matters, call us directly.
                  </p>
                  <p className="text-[10px] text-muted-foreground/60 mt-1 font-mono">
                    * This is a message capture form — not a live chat
                  </p>
                </div>

                <form onSubmit={handleSubmit} className="space-y-3">
                  <input
                    type="text"
                    placeholder="Your Name *"
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    required
                    className="input-field w-full px-3 py-2.5 text-sm"
                  />
                  <input
                    type="tel"
                    placeholder="Phone Number"
                    value={formData.phone}
                    onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                    className="input-field w-full px-3 py-2.5 text-sm"
                  />
                  <input
                    type="email"
                    placeholder="Email Address *"
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    required
                    className="input-field w-full px-3 py-2.5 text-sm"
                  />
                  <textarea
                    placeholder="Your message... *"
                    value={formData.message}
                    onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                    required
                    rows={3}
                    className="input-field w-full px-3 py-2.5 text-sm resize-none"
                  />
                  <button type="submit" className="btn-primary w-full py-2.5 text-sm flex items-center justify-center gap-2">
                    <Icon name="PaperAirplaneIcon" size={15} />
                    Send Message
                  </button>
                </form>

                <div className="mt-3 flex flex-col gap-1.5">
                  <p className="text-[10px] text-muted-foreground text-center">Or call us directly:</p>
                  <div className="flex gap-2">
                    <a href="tel:9851075502" className="flex-1 flex items-center justify-center gap-1.5 py-2 bg-muted rounded-lg text-xs font-medium text-foreground hover:bg-muted/80 transition-colors">
                      <Icon name="PhoneIcon" size={13} className="text-primary" />
                      9851075502
                    </a>
                    <a href="tel:9841273772" className="flex-1 flex items-center justify-center gap-1.5 py-2 bg-muted rounded-lg text-xs font-medium text-foreground hover:bg-muted/80 transition-colors">
                      <Icon name="PhoneIcon" size={13} className="text-primary" />
                      9841273772
                    </a>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      )}

      {/* Toggle Button */}
      <button
        onClick={() => setOpen(!open)}
        className="chat-bubble w-14 h-14 rounded-full flex items-center justify-center text-white transition-all duration-300 hover:scale-110 animate-pulse-glow"
        aria-label={open ? 'Close chat' : 'Open chat'}
      >
        <Icon name={open ? 'XMarkIcon' : 'ChatBubbleLeftRightIcon'} size={24} />
      </button>
    </div>
  );
}